import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/contact-pricing")({
  head: () => ({
    meta: [
      { title: "Contact unlock pricing · Landoo Super Admin" },
      { name: "description", content: "Contact unlock pricing — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Contact unlock pricing" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Contact unlock pricing"
        description="Super admin management surface for Contact unlock pricing."
      />
    </DashboardShell>
  ),
});
